import axios from 'axios';

axios.interceptors.request.use(
    function(config) {
      // 在请求发出之前进行处理
      if(config.url=="/noise/user/login"){
            config.headers.common['token'] = '';
        }else{
            var token=sessionStorage.getItem("token");
            config.headers.common['token'] =  token
        }
      return config
    },
    function(error) {
      // 对请求错误做些什么
      return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    function(response) {
        // 对响应数据做些事情
        return response
    },
    function(error) {
        if (error.response.status) {            
            switch (error.response.status) {  
                // 401: 未登录                
                // 未登录则跳转登录页面，并携带当前页面的路径                
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:                    
                    break;
                case 405:     
                    location.href = '/#/login';            
                    break;
                case 504:     
                    location.href = '/#/login';       
                    break;
                case 500:    
                    location.href = '/#/login';       
                    break;
            }
        }
        // 对请求错误做些事情
        return Promise.reject(error)
    }
)

//登录
export const requestLogin = params => {
    return axios.post(`/noise/user/login`, params ); 
};
//判断用户是否登录并查询权限
export const fromIndex = params => {
    return axios.get(`/noise/user/info`,  { params: params }); 
};

//获取用户列表（条件）
export const getUserList = params => {
    return axios.get(`/noise/user/pageList`, { params: params }); 
};
export const getUsers = params => {
    return axios.get(`/noise/user/selectList`, { params: params }); 
};
//添加用户
export const addUser = params => {
    return axios.post(`/noise/user/add`, params); 
};
//修改用户
export const updateUser = params => {
    return axios.post(`/noise/user/edit`, params); 
};
export const setFatherUser = params => {
    return axios.post(`/noise/user/setParentUser`, params); 
};
//密码重置
export const editPwd = params => {
    return axios.post(`/noise/user/editPwd`, params); 
};
//首页修改密码
export const userQueryPermisson = params => { 
    return axios.get(`/noise/projects/selectProjectsForUser/`+params.userId, { params: params }); 
};
export const userAddPermission  = params => { 
    return axios.post(`/noise/projects/grantProjectForUser/`+params.get("userId"), params); 
};


//角色管理
//获取所有角色
export const getRoles = params => {
    return axios.get(`/noise/roles/selectList`, { params: params }); 
};
//获取角色列表（条件）
export const getRoleList = params => {
    return axios.get(`/noise/roles/pageList`, { params: params }); 
};
export const saveOrUpdateRole  = params => { 
    return axios.post(`/noise/roles/saveOrUpdate`, params); 
};

export const roleQueryPermisson = params => { 
    return axios.get(`/noise/permissions/selectPermissionsForRole/`+params.roleId, { params: params }); 
};
export const roleAddPermission  = params => { 
    return axios.post(`/noise/permissions/grantPermissionForRole/`+params.get("roleId"), params); 
};

//因子管理
export const getFactorList = params => { 
    return axios.get(`/noise/getFactorList`, { params: params }); 
};
export const getFactors = params => { 
    return axios.get(`/noise/getFactors`, { params: params }); 
};
export const getFactorNoise = params => { 
    return axios.get(`/noise/getFactorNoise`, { params: params }); 
};
export const addFactor = params => {
    return axios.post(`/noise/addFactor`, params); 
};
export const updateFactor = params => {
    return axios.post(`/noise/updateFactor`, params); 
};


//设备类型管理
export const getDeviceTypeList = params => {
    return axios.get(`/noise/getDeviceTypeList`, { params: params }); 
};
export const getDeviceTypes = params => {
    return axios.get(`/noise/getDeviceTypes`, { params: params }); 
};
export const addDeviceType = params => { 
    return axios.post(`/noise/addDeviceType`, params); 
};
export const updateDeviceType = params => { 
    return axios.post(`/noise/updateDeviceType`, params); 
};

//项目管理
export const getProjectList = params => { 
    return axios.get(`/noise/projects/pageList`, { params: params }); 
};
export const getProjects = params => { 
    return axios.get(`/noise/projects/selectList`, { params: params }); 
};
export const addProject = params => {
    return axios.post(`/noise/projects/add`, params); 
};
export const updateProject = params => {
    return axios.post(`/noise/projects/edit`, params); 
};
export const setFatherProject = params => {
    return axios.post(`/noise/projects/setParentProject`, params); 
};
export const getProjectsTree = params => { 
    return axios.get(`/noise/projects/treeList`, { params: params }); 
};

//设备管理
export const getDeviceList = params => { 
    return axios.get(`/noise/devices/pageList`, { params: params });
 };
 export const getDevices = params => { 
    return axios.get(`/noise/devices/selectList`, { params: params });
 };
 export const getDevicesByProjectId = params => { 
    return axios.get(`/noise/getDevicesByProjectId`, { params: params });
 };
export const deleteDevices = params => { 
    return axios.post(`/noise/devices/delete/`+params.ids, params); 
};
export const addDevice = params => { 
    return axios.post(`/noise/devices/add`, params); 
};
export const updateDevice = params => { 
    return axios.post(`/noise/devices/edit`, params); 
};
export const setProject = params => { 
    return axios.post(`/noise/devices/grantDeviceForProject/`+params.get("projectId"), params); 
};
export const getDevicePic = params => { 
    return axios.get(`/noise/getDevicePic`, { params: params });
 };

 export const uploadFile = params => { 
    return axios.post(`/noise/devices/uploadPic/`+params.get("deviceId"), params); 
};
export const importExcle = params => { //todo 暂时忽略 后续考虑设备经纬度问题
    params=Object.assign(params, {action:'importExcle'});  
    return axios.post(`/ashx/deviceManage/DeviceMa.ashx`, params); 
};
export const exportDeviceExcle = params => { 
    return axios.get(`/noise/devices/export`, { params: params });
 };

 export const downloadFileBlob = params => {
    axios({
      url: '/noise/devices/export?mnCode='+params.mnCode+'&projectIds='+params.projectIds,
      method: 'GET',
      responseType: 'blob', // 指定响应数据类型为Blob
    })
    .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '设备信息.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    })
    .catch(error => {
        console.error('下载失败', error);
    });
  
 }

export const getFunctionalAreaList = params => { 
    return axios.get(`/noise/getFunctionalAreaList`, { params: params });
};
export const setSSR = params => { 
    return axios.post(`/noise/devices/setSSRToProject`, params); 
};

//实时数据查询 最新一条数据
export const getRealDataList = params => { 
    return axios.get(`/noise/getRealDataList`, { params: params }); 
};
export const getRealDataForWeb = params => { 
    return axios.get(`/noise/getRealDataForWeb`, { params: params }); 
};

//分钟历史数据查询
export const fetchExceptionData = params => { 
    return axios.get(`/noise/fetchExceptionData`, { params: params });
};
 export const getFactorsByMn = params => { 
    return axios.get(`/noise/getFactorsByMn`, { params: params });
 };

 //获取历史频谱数据
export const getHistorySpectrum = params => { 
    return axios.get(`/noise/spectrum/data`, { params: params }); 
};


//操作日志
export const getOptLog = params => { 
    return axios.get(`/noise/operationLog/pageList`, { params: params }); 
};

// 报表
export const bornDayForm = params => { 
    return axios.get(`/noise/report/day`, { params: params }); 
};
export const bornWeekForm = params => { 
    return axios.get(`/noise/report/report`, { params: params }); 
};
export const bornMonthForm = params => { 
    return axios.get(`/noise/report/report`, { params: params }); 
};
export const bornSeasonForm = params => { 
    return axios.get(`/noise/report/report`, { params: params }); 
};
export const bornYearForm = params => { 
    return axios.get(`/noise/report/report`, { params: params }); 
};
export const bornCustomForm = params => { 
    return axios.get(`/noise/report/custom`, { params: params }); 
};
export const bornHourForm = params => { 
    return axios.get(`/noise/report/hour`, { params: params }); 
};
export const generateForDay = params => { 
    return axios.get(`/noise/report/generateForDay`, { params: params }); 
};
//设置报表因子
export const addAndUpdateFormSet = params => { 
    return axios.post(`/noise/report/config/update`, params); 
};
export const deleteFormSet = params => { 
    return axios.post(`/noise/report/config/delete`, params); 
};
export const getFormSetList = params => { 
    return axios.get(`/noise/report/config/list`, { params: params }); 
};
 export const getParam = params => { // 待定
    // string mn =  context.Request["mn"].ToString();
    // string param =  context.Request["param"].ToString();
    // string sql = "SELECT sn" + param + " FROM deviceparams where mn='" + mn + "' ORDER BY online";
    // DataTable   dt = MySqlHelper.GetDataSetByConn(MySqlHelper.connStr7000, sql, null).Tables[0];
    // context.Response.Write(JsonHelper.JsonToString(new { realDatas=dt}));
    params=Object.assign(params, {action:'getParam'});
    return axios.get(`/ashx/noiseManage/NoiseValidManage.ashx`, { params: params });
 };
//异常噪声
export const getNoiseSpectrum = params => { 
    //设备未存在此功能，等后边在进行添加 超标数据联动频谱
    //http://localhost:8083/ashx/noiseManage/NoiseValidManage.ashx?mn=HC700022100009&time=2024-07-26+06:00:00&action=getNoiseSpectrum
    //返回数值为数据库数据    
    //需要可以打开，目前有的平台都一直传频谱数据了，分钟级的  之前有，后来关了
};

//数据审核
export const getReviewWay = params => { 
    return axios.get(`/noise/review/getReviewWay`,  { params: params }); 
};

export const getReviewSetList = params => { 
    return axios.get(`/noise/review/getReviewSetList`, { params: params }); 
};
export const deleteReviewSets = params => { 
    return axios.post(`/noise/review/deleteReviewSet`, params); 
};
export const addReviewSet = params => { 
    return axios.post(`/noise/review/addReviewSet`, params); 
};
export const updateReviewSet = params => { 
    return axios.post(`/noise/review/updateReviewSet`, params); 
};

export const getExceptionList = params => {  
    return axios.get(`/noise/getExceptionList`,  { params: params }); 
};

export const changeExceptionStatus = params => { 
    return axios.post(`/noise/review/changeExceptionStatus`, params); 
};

//Java接口 统计
export const getSingleDay = params => { 
    return axios.get(`/noise/getSingleDay`, { params: params }); 
};
export const getChooseDay = params => { 
    return axios.get(`/noise/getChooseDay`, { params: params }); 
};
export const getComplianceRate = params => { 
    return axios.get(`/noise/getComplianceRate`, { params: params }); 
};
//审核
export const getExamineDayList = params => { 
    return axios.get(`/noise/getExamineDayList`, { params: params }); 
};
export const getExamineHourList = params => { 
    return axios.get(`/noise/getExamineHourList`, { params: params }); 
};
export const getReasonList = params => { 
    return axios.get(`/noise/getReasonList`, { params: params }); 
};
export const reviewHourData = params => { 
    return axios.post(`/noise/reviewHourData`, params); 
};
export const reviewDayData = params => { 
    return axios.post(`/noise/reviewHourData`, params); 
};

export const getExcessiveCount = params => { 
    return axios.get(`/noise/getExcessiveCount`, { params: params }); 
};
export const getExcessiveDataDetail = params => { 
    return axios.get(`/noise/getExcessiveDataDetail`, { params: params }); 
};

export const queryNoiseRecording = params => { 
    params=Object.assign(params, {action:'queryNoiseRecording'});
    return axios.get(`/noise/queryNoiseRecording`, { params: params });
 };

//人工数据
export const getAnalysisData = params => { 
    return axios.get(`/noise/getAnalysisData`, { params: params }); 
};
export const selectHandView = params => { 
    return axios.get(`/noise/selectHandView`, { params: params }); 
};
export const deleteAndUpdataHandView = params => { 
    return axios.post(`/noise/deleteAndUpdataHandView`, params); 
};
export const addHandView = params => { 
    return axios.post(`/noise/addHandView`, params); 
};
//导入
export const uploadHandView = params => { 
    return axios.post(`/noise/uploadHandView`, params); 
};
//导出
export const exportHandData = params => { 
    return axios.get(`/noise/exportHandData`, { params: params }); 
};

//运维管理
export const getOperationCompanyList = params => { 
    return axios.get(`/noise/getOperationCompanyList`, { params: params }); 
};
export const getSystemUserList = params => { 
    return axios.get(`/noise/getSystemUserList`, { params: params }); 
};
export const getUserDevopsList = params => { 
    return axios.get(`/noise/getUserDevopsList`, { params: params }); 
};
export const deleteUserDevopss = params => { 
    return axios.post(`/noise/deleteUserDevopss`, params); 
};
export const updateUserDevops = params => { 
    return axios.post(`/noise/updateUserDevops`, params); 
};
export const addUserDevops = params => { 
    return axios.post(`/noise/addUserDevops`, params); 
};

export const getDeviceCailsList = params => { 
    return axios.get(`/noise/getDeviceCailsList`, { params: params }); 
};
export const deleteDeviceCails = params => { 
    return axios.post(`/noise/deleteDeviceCails`, params); 
};
export const updateDeviceCails = params => { 
    return axios.post(`/noise/updateDeviceCails`, params); 
};
export const addDeviceCails = params => { 
    return axios.post(`/noise/addDeviceCails`, params); 
};
export const getAllDeviceCailsList = params => { 
    return axios.get(`/noise/getAllDeviceCailsList`, { params: params }); 
};
export const getCalibrationRecordsList = params => { 
    return axios.get(`/noise/getCalibrationRecordsList`, { params: params }); 
};
export const deleteCalibrationRecords = params => { 
    return axios.post(`/noise/deleteCalibrationRecords`, params); 
};
export const updateCalibrationRecords = params => { 
    return axios.post(`/noise/updateCalibrationRecords`, params); 
};
export const addCalibrationRecords = params => { 
    return axios.post(`/noise/addCalibrationRecords`, params); 
};
export const getMaintenanceStatus = params => { 
    return axios.get(`/noise/getMaintenanceStatus`, { params: params }); 
};
export const getMaintenanceRecord = params => { 
    return axios.get(`/noise/getMaintenanceRecord`, { params: params }); 
};
export const addMaintenanceRecord = params => { 
    return axios.post(`/noise/addMaintenanceRecord`, params); 
};
export const updateMaintenanceRecord = params => { 
    return axios.post(`/noise/updateMaintenanceRecord`, params); 
};
export const deleteMaintenanceRecord = params => { 
    return axios.post(`/noise/deleteMaintenanceRecord`, params); 
};
export const selectDeviceInspectionRecord = params => { 
    return axios.get(`/noise/selectDeviceInspectionRecord`, { params: params }); 
};
export const addDeviceInspectionRecord = params => { 
    return axios.post(`/noise/addDeviceInspectionRecord`, params); 
};
export const updateDeviceInspectionRecord = params => { 
    return axios.post(`/noise/updateDeviceInspectionRecord`, params); 
};
export const deleteDeviceInspectionRecord = params => { 
    return axios.post(`/noise/deleteDeviceInspectionRecord`, params); 
};


//声源识别
export const handleIdent = params => { 
    return axios.post(`/soundrecognition/handleIdent`, params); 
};
export const getSoundTypeList = params => { 
    return axios.get(`/soundrecognition/getSoundTypeList`, { params: params }); 
};
export const updateSoundType = params => { 
    return axios.post(`/soundrecognition/updateSoundType`, params); 
};
export const addSoundType = params => { 
    return axios.post(`/soundrecognition/addSoundType`, params); 
};
export const peopleIdent = params => { 
    return axios.post(`/soundrecognition/manualLabeling`, params); 
};
export const deleteSound = params => { 
    return axios.post(`/soundrecognition/deleteSoundType`, params); 
};

//第二版新增
export const getEventList = params => { 
    return axios.get(`/noise/getEventList`, { params: params }); 
};

export const getDataCollectionRate = params => { 
    return axios.get(`/noise/getDataCollectionRate`, { params: params }); 
};
export const getTimeDistributionChartData = params => { 
    return axios.get(`/noise/getTimeDistributionChartData`, { params: params }); 
};
export const getTimeDistributionChartDataContent = params => { 
    return axios.get(`/noise/getTimeDistributionChartDataContent`, { params: params }); 
};
export const getDailyMaintRecords = params => { 
    return axios.get(`/noise/getDailyMaintRecords`, { params: params }); 
};
export const getVersionHistoryList = params => { 
    return axios.get(`/noise/getVersionHistoryList`, { params: params }); 
};
export const getExamineMinuteList = params => { 
    return axios.get(`/noise/getExamineMinuteList`, { params: params }); 
};
export const reviewMinuteData = params => { 
    return axios.post(`/noise/reviewMinuteData`, params); 
};

export const selectHourDataList = params => { 
    return axios.get(`/noise/selectHourDataList`, { params: params }); 
};
export const selectDayDataList = params => { 
    return axios.get(`/noise/selectDayDataList`, { params: params }); 
};
export const noiseFileData = params => { 
    return axios.get(`/noise/noiseFileData`, { params: params }); 
};
//声源定位
export const findAlarmData = params => { 
    return axios.get(`/noise/findAlarmData`, { params: params }); 
};
export const exportToExcel = params => { 
    return axios.get(`/noise/exportToExcel`, { params: params }); 
};
export const selectNoiseDataForTime = params => { 
    return axios.get(`/noise/selectNoiseData4Time`, { params: params }); 
};
export const selectStatisticsNoiseData = params => { 
    return axios.get(`/noise/selectStatisticsNoiseData`, { params: params }); 
};


//数据转发
export const selectSha256CheckDigit = params => { 
    return axios.get(`/noise/selectSha256CheckDigit`, { params: params }); 
};
export const insertSha256CheckDigit = params => { 
    return axios.post(`/noise/insertSha256CheckDigit`, params); 
};
export const updateSha256CheckDigit = params => { 
    return axios.post(`/noise/updateSha256CheckDigit`, params); 
};

//根据月份获取噪声日历 审核和单点位污染日历图
export const selectNoiseCalendar = params => { 
    return axios.get(`/noise/selectNoiseCalendar/`+params.mn, { params: params }); 
};
//审核日历图
export const selectNoiseTrend = params => { 
    return axios.get(`/noise/selectNoiseTrend/`+params.mn, { params: params }); 
};
//污染日历
export const selectPollutionCalendar = params => { 
    return axios.get(`/noise/selectPollutionCalendar`, { params: params }); 
};
//超标数据统计
export const selectExceedData = params => { 
    return axios.get(`/noise/selectExceedData`, { params: params }); 
};
//排名
export const selectNoiseDataForRank = params => { 
    return axios.get(`/noise/selectNoiseDataForRank`, { params: params }); 
};
export const selectContrastList = params => { 
    return axios.get(`/noise/selectContrastList`, { params: params }); 
};
//同比环比
export const selectReviewList = params => { 
    return axios.get(`/noise/selectReviewList`, { params: params }); 
};

//获取车流量信息
export const getCarDataByMN = params => { 
    return axios.get(`/noise/trafficFlow/info`, { params: params }); 
};

//获取声纹识别信息
export const getVoiceprintRecognitionList = params => { 
    return axios.get(`/noise/selectVoiceprint`, { params: params }); 
};
export const retransmission = params => { 
    return axios.post(`/noise/device/retransmission`, params); 
};
export const setParams = params => { 
    return axios.post(`/noise/device/setParams`, params); 
};
export const getParams = params => { 
    return axios.get(`/noise/device/getParams`, { params: params }); 
};
export const selectAcousticCamera = params => { 
    return axios.get(`/noise/selectAcousticCamera`, { params: params }); 
};

//获取秒数据
export const selectSecondData = params => { 
    return axios.get(`/noise/selectSecondData`, { params: params }); 
};



//机场噪声接口
export const selectMonitoringRecord = params => { 
    return axios.get(`/noise/airport/selectMonitoringRecord`, { params: params }); 
};
export const selectData = params => { 
    return axios.get(`/noise/airport/selectData`, { params: params }); 
};

//吉林 四平 白山数据补传 dataAddByMN
export const dataForwardForJL = params => { 
    return axios.post(`/noise/dataForwardForJL`, params); 
};



// WEBPACK FOOTER //
// ./src/api/api.js